/* Snugs PDP (snx) behaviour */
(function(){
  if (window.__snxInit) return; window.__snxInit = true;
  document.documentElement.classList.add('snx-hero-on');
  document.body && document.body.classList.add('snx-hero-on');

  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function(){
    document.body.classList.add('snx-hero-on');

    /* Feature pins <-> accordion rows */
    document.querySelectorAll('[data-snx-features]').forEach(function(root){
      var pins = root.querySelectorAll('.snx-pin');
      var rows = root.querySelectorAll('details[data-pin]');
      function sync(){
        var open = root.querySelector('details[data-pin][open]');
        var n = open ? open.getAttribute('data-pin') : null;
        pins.forEach(function(p){ p.classList.toggle('is-active', p.getAttribute('data-pin') === n); });
      }
      rows.forEach(function(d){
        d.addEventListener('toggle', function(){
          if (d.open) root.querySelectorAll('details.snx-acc[open]').forEach(function(o){ if(o!==d) o.open=false; });
          sync();
        });
      });
      root.querySelectorAll('details.snx-acc:not([data-pin])').forEach(function(d){
        d.addEventListener('toggle', function(){ if(d.open){ root.querySelectorAll('details.snx-acc[open]').forEach(function(o){ if(o!==d) o.open=false; }); } sync(); });
      });
      pins.forEach(function(p){
        p.addEventListener('click', function(){
          var d = root.querySelector('details[data-pin="'+p.getAttribute('data-pin')+'"]');
          if (!d) return; d.open = true;
          if (window.matchMedia('(max-width: 989px)').matches) d.scrollIntoView({behavior:'smooth', block:'center'});
        });
      });
      sync();
    });

    /* Ships today / order-before-2PM countdown (IST) */
    document.querySelectorAll('[data-snx-ships]').forEach(function(el){
      var cut = (el.getAttribute('data-cutoff') || '14:00').split(':');
      var cutMin = parseInt(cut[0],10)*60 + parseInt(cut[1]||'0',10);
      var label = el.querySelector('.snx-ships__label'), sub = el.querySelector('.snx-ships__sub'), timer = el.querySelector('[data-snx-ships-timer]');
      function istNow(){ var d = new Date(); return new Date(d.getTime() + (d.getTimezoneOffset() + 330) * 60000); }
      function pad(n){ return (n < 10 ? '0' : '') + n; }
      function tick(){
        var n = istNow(); var mins = n.getHours()*60 + n.getMinutes(); var secs = n.getSeconds();
        var left = (cutMin - mins) * 60 - secs; var today = left > 0;
        if (!today) left += 24*60*60;
        var hh = Math.floor(left/3600), mm = Math.floor((left%3600)/60), ss = left%60;
        label.textContent = today ? 'Ships today' : 'Ships tomorrow';
        sub.textContent = today ? 'if you order in the next' : 'order before 2 PM for same-day dispatch';
        if (today){ timer.hidden = false; timer.textContent = pad(hh)+':'+pad(mm)+':'+pad(ss); } else { timer.hidden = true; }
      }
      tick(); setInterval(tick, 1000);
    });

    /* Lightbox for demo videos */
    var dlg = document.getElementById('snx-lightbox');
    document.querySelectorAll('[data-snx-play]').forEach(function(btn){
      btn.addEventListener('click', function(){
        if (!dlg) return;
        var media = btn.closest('.snx-media');
        var inline = media ? media.querySelector('video') : null;
        var src = btn.getAttribute('data-snx-play') || (inline ? (inline.currentSrc || inline.getAttribute('src')) : '');
        var poster = inline ? (inline.getAttribute('poster') || '') : '';
        var img = btn.getAttribute('data-snx-img');
        var stage = dlg.querySelector('.snx-lightbox__stage');
        stage.innerHTML = '';
        if (src){
          var v = document.createElement('video');
          v.src = src; v.controls = true; v.playsInline = true; v.autoplay = true; if (poster) v.poster = poster;
          stage.appendChild(v);
          setTimeout(function(){ var p = v.play(); if (p && p.catch) p.catch(function(){}); }, 30);
        } else if (img){
          var im = document.createElement('img'); im.src = img; im.alt = ''; stage.appendChild(im);
        } else { return; }
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open','');
      });
    });
    if (dlg){
      dlg.addEventListener('close', function(){ var s=dlg.querySelector('.snx-lightbox__stage'); if(s) s.innerHTML=''; });
      dlg.addEventListener('click', function(e){ if (e.target === dlg) dlg.close(); });
      var c = dlg.querySelector('.snx-lightbox__close'); if (c) c.addEventListener('click', function(){ dlg.close(); });
    }

    /* Inline loop videos only play when visible */
    var vids = document.querySelectorAll('video[data-snx-loop]');
    if ('IntersectionObserver' in window){
      var vo = new IntersectionObserver(function(es){ es.forEach(function(e){ var v=e.target; if(e.isIntersecting){ var p=v.play(); if(p&&p.catch)p.catch(function(){}); } else v.pause(); }); }, {threshold:.25});
      vids.forEach(function(v){ vo.observe(v); });
    }

    /* Reveal on scroll */
    var rv = document.querySelectorAll('.snx-reveal');
    if ('IntersectionObserver' in window){
      var ro = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); ro.unobserve(e.target); } }); }, {rootMargin:'0px 0px -8% 0px'});
      rv.forEach(function(el){ ro.observe(el); });
    } else rv.forEach(function(el){ el.classList.add('is-in'); });

    /* Review cards: read more */
    document.querySelectorAll('.snx-review').forEach(function(card){
      var t = card.querySelector('.snx-review__text'), b = card.querySelector('.snx-review__more');
      if (!t || !b) return;
      if (t.scrollHeight <= t.clientHeight + 2) { b.hidden = true; }
      b.addEventListener('click', function(){ var o = card.classList.toggle('is-open'); b.textContent = o ? b.getAttribute('data-less') : b.getAttribute('data-more'); });
    });

    /* View all reviews: reveals the full Loox widget */
    /* move the full widget so it opens right under the button, not at the bottom of the page */
    (function(){
      var btn = document.querySelector('[data-snx-all-reviews]');
      var sec = document.querySelector('[id$="__snx_loox_all"]');
      if (btn && sec) { var host = btn.closest('.snx-reviews__all') || btn; host.parentNode.insertBefore(sec, host.nextSibling); sec.classList.add('snx-loox-inline'); }
    })();
    document.querySelectorAll('[data-snx-all-reviews]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var sec = document.querySelector('[id$="__snx_loox_all"]');
        if (!sec) return;
        var open = sec.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
        if (!open) btn.scrollIntoView({behavior:'smooth', block:'center'});
      });
    });

    /* Closing CTA: uses the main Add to Cart (same cart drawer + tracking) */
    document.querySelectorAll('[data-snx-atc]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        var main = document.querySelector('product-info button.product-form__submit[name="add"], button.product-form__submit[name="add"]');
        if (main && !main.disabled){ e.preventDefault(); main.click(); }
      });
    });

    /* Button label per brief: "Add to Cart" */
    document.querySelectorAll('product-info button.product-form__submit[name="add"] .btn-text > span:first-child').forEach(function(sp){ if (/^\s*add to cart\s*$/i.test(sp.textContent)) sp.textContent = 'Add to Cart'; });
    /* Buy Now: outlined style over the Magic Checkout button (same click target) */
    function dressBuyNow(){
      var parent = document.querySelector('product-info .magic-buy-btn__parent');
      if (!parent || parent.classList.contains('snx-bn-ready')) return !!parent;
      var m = parent.querySelector('magic-checkout-btn');
      if (!m || m.offsetHeight < 30) return false;
      var label = document.createElement('span');
      label.className = 'snx-buynow'; label.setAttribute('aria-hidden','true'); label.textContent = 'Buy Now';
      parent.appendChild(label); parent.classList.add('snx-bn-ready');
      return true;
    }
    var tries = 0, t = setInterval(function(){ if (dressBuyNow() || ++tries > 40) clearInterval(t); }, 250);
  });
})();
